const fontData = {
  'Noto Sans': [
    {
      sources: [
        {
          url: '/fonts/NotoSansHebrew/NotoSansHebrew-hebrew.woff2',
          format: 'woff2',
        },
      ],
      unicodeRange: 'U+0022, U+0030-0039, U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F',
    },
    {
      sources: [
        {
          url: '/fonts/NotoSansHebrew/NotoSansHebrew-latin.woff2',
          format: 'woff2',
        },
      ],
      unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
  ],
  'Open Sans': [
    {
      sources: [
        {
          url: '/fonts/OpenSans/OpenSans-hebrew.woff2',
          format: 'woff2',
        },
      ],
      unicodeRange: 'U+0022, U+0030-0039, U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F',
    },
    {
      sources: [
        {
          url: '/fonts/OpenSans/OpenSans-latin.woff2',
          format: 'woff2',
        },
      ],
      unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
  ],
  'EzerRutz': [
    {
      sources: [
        {
          url: '/fonts/EzerRutz/EzerRutz-Bold.woff2',
          format: 'woff2',
        },
      ],
      unicodeRange: 'U+0022, U+0030-0039, U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F',
    },
    {
      sources: [
        {
          url: '/fonts/EzerRutz/EzerRutz-Bold.woff2',
          format: 'woff2',
        },
      ],
      unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
  ],
  'Caravan': [
    {
      sources: [
        {
          url: '/fonts/Caravan/Caravan.woff2',
          format: 'woff2',
        },
      ],
      unicodeRange: 'U+0022, U+0030-0039, U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F',
    },
  ],
};

export default fontData;